import { useState } from 'react';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import {getAuth ,signUp ,signIn } from '../../actions/auth'
import {GoogleLogin} from 'react-google-login';
import {Container,Typography,Avatar,Paper,Grid,Button, TextField,InputAdornment, IconButton, CircularProgress} from '@mui/material'
import LockIcon from '@mui/icons-material/Lock';
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';


const Auth = () => {
    
    const dispatch = useDispatch();       //getting the dispatch function   
    const navigate = useNavigate();       //getting the router-dom navigate function = useHistory upgrade
    
    const [isSignup,setIsSignup] = useState(false) ;       //store the value if user registering or user exsists already trying to log-in
    const [showPassword, setShowPassword] = useState(false);    //state to show or hide the password (eye icon)
    const [loading, setLoading]= useState(false);               //state to store if user sing is  loading
    
    const switchMode = () => {          //for sign-in/sing-up switching button
        setIsSignup(!isSignup);
        setShowPassword(false);
    };

    //google svg icon & (googleSucces, googleFailure) functions, we pass them to the google login button 
    const icon = <svg style={{ width: '20px', height: '20px' }} viewBox="0 0 24 24">
                   <path fill="currentColor" d="M21.35,11.1H12.18V13.83H18.69C18.36,17.64 15.19,19.27 12.19,19.27C8.36,19.27 5,16.25 5,12C5,7.9 8.2,4.73 12.2,4.73C15.29,4.73 17.1,6.7 17.1,6.7L19,4.72C19,4.72 16.56,2 12.1,2C6.42,2 2.03,6.8 2.03,12C2.03,17.05 6.16,22 12.25,22C17.6,22 21.5,18.33 21.5,12.91C21.5,11.76 21.35,11.1 21.35,11.1V11.1Z" />
                 </svg> ;
    const googleSucces = async (res) => {
        const result = res?.profileObj ;        //the user info object
        const token = res?.tokenId ;           //Token authentication to verify user identity        
        try {
            dispatch(getAuth(result,token));
            navigate('/');
        } catch (error) {
            console.log(error)
        }
    };
    const googleFailure = () => {                
        console.log('Google sing in not succesful .. try again later')
    };
      
    //state for all the data inside our form
    const [formData, setFormData] = useState({firstName:'',lastName:'',email:'',password:'',confirmPassword:''}) ;
    //function to get each input & put it inside the formData state
    const handleChange = (e)=>{        
        setFormData({...formData , [e.target.name] : e.target.value })
    };
     //function to handle the form submit
    const handleSubmit = (e)=>{       
        e.preventDefault();
        setLoading(true);
        if(isSignup){                //a new user trying to register
            dispatch(signUp(formData,navigate));                       
        }else{                     //exsisting user trying to log in
            dispatch(signIn(formData,navigate));                       
        }
    };

  return (   //render the sign forms using material ui components
    <Container component='main' maxWidth='xs'> 
        <Paper elevation={3} sx={{marginTop:'15px',display: 'flex',flexDirection: 'column',alignItems: 'center',padding:'12px'}}>
            
            <Avatar sx={{margin:'5px',backgroundColor:'#9c27b0'}}><LockIcon /></Avatar>
            <Typography variant='h5'>{isSignup? 'Sign up' : 'Sign in' }</Typography>
           
            <form onSubmit={handleSubmit} style={{ width: '100%', marginTop:'25px'}}>
                <Grid container spacing={2}>

                    {/*if it's a new user (show name textfields first at the begining )  */}
                    {isSignup && (<>
                           <Grid item sm={12} xs={12}><TextField name='firstName' label='First Name' variant='outlined' xs={6} onChange={handleChange} autoFocus fullWidth required/></Grid>
                           <Grid item sm={12} xs={12}><TextField name='lastName' label='Last Name' variant='outlined' xs={6} onChange={handleChange} fullWidth required/></Grid>
                    </>)}    

                     {/*if the user is registered (show only email & pass inputs) ,
                        if new user (also show them but after the names inputs) */}
                    <Grid item sm={12} xs={12}>
                        <TextField name='email' label='Email Address' variant='outlined' onChange={handleChange} type='email' fullWidth required />
                    </Grid>
                    <Grid item sm={12} xs={12}>
                        <TextField name='password' label='Password' variant='outlined' onChange={handleChange} type={showPassword?'text':'password'} fullWidth required
                        InputProps={{endAdornment:<InputAdornment position="end"><IconButton onClick={()=>{setShowPassword(!showPassword)}}> {(showPassword) ? <VisibilityOffIcon /> : <VisibilityIcon />} </IconButton> </InputAdornment>}} />                       
                    </Grid>
                    
                    {/*if it's a new user (show all the above first then show repeat password input ) : */}
                    {isSignup && <Grid item sm={12} xs={12}><TextField name="confirmPassword" label="Repeat Password" variant='outlined' onChange={handleChange} type="password" fullWidth required /></Grid>}

                    <Button type="submit" disabled={loading} fullWidth variant="contained" color="primary" sx={{margin:'20px 15px 5px'}}>
                        { isSignup ? 'Sign Up' : 'Sign In' }
                    </Button>
                    
                    <GoogleLogin clientId='643763621693-avjun8ie4tr6hqsgk5cr0dkth1ks8jfh.apps.googleusercontent.com' 
                                 onSuccess={googleSucces} onFailure={googleFailure} cookiePolicy='single_host_origin' 
                                 render={(renderProps)=>(
                                 <Button sx={{margin:'12px 12px 0'}} color='primary' variant='contained' startIcon={icon} fullWidth onClick={renderProps.onClick} disabled={renderProps.disabled} >
                                      Google Sign In 
                                 </Button>)} />

                    {loading && <CircularProgress sx={{margin:"10px auto"}}/>}            
                    <Grid container justify="flex-end">
                        <Grid item> <Button onClick={switchMode} sx={{margin:'15px 10px 5px'}} > 
                              { isSignup ? 'Already have an account? Sign in' : "Don't have an account? Sign Up" } 
                         </Button>                         
                         </Grid>
                    </Grid>

                </Grid>
            </form>
        </Paper>
    </Container>
  )
}

export default Auth